import DocumentsApi from '@app/api/public/DocumentsApi';
import { useQuery } from 'react-query';
import { folderKeys } from '../../queryKeys';

const useGetFolderById = (id: number) => {
    return useQuery([...folderKeys.detail(id)], () => DocumentsApi.getFolderById(id));
};

export default useGetFolderById;
